<template>
  <v-dialog
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    width="950"
    :value="true"
  >
    <v-toolbar color="primary" dark flat class="cvi-dialog-toolbar">
      <v-toolbar-title class="d-flex flex-column justify-center">
        <span
          class="text-h6"
          v-text="
            `${inscricaoLocal.matricula.pessoa.nome} (${format(
              parseISO(inscricaoLocal.matricula.pessoa.data_nascimento),
              'dd/MM/yyyy',
            )}) - ${inscricaoLocal.matricula.status}`
          "
        />

        <span
          class="text-caption"
          v-text="
            `Matrícula: ${inscricaoLocal.matricula.codigo} ${
              etapaAtual ? ' - ' + etapaAtual : ''
            } | ${inscricaoLocal.matricula.unidadeEnsino.nomeCompleto}`
          "
        />
      </v-toolbar-title>

      <v-spacer />

      <v-btn icon @click="$emit('close')">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-toolbar>
    <v-card v-if="!enturmacoes.length && !loading" :loading="loading">
      <v-card-title class="d-flex justify-center">
        Aluno sem enturmação!
      </v-card-title>
      <v-card-text class="d-flex justify-center" style="white-space: pre-wrap;">
        Enturme o aluno no <span class="font-weight-bold ">Erudio</span> e
        retorne para editar este cadastro.
      </v-card-text>
    </v-card>
    <v-card v-else color="grey lighten-5" :loading="loading">
      <v-card-text>
        <primeira-secao
          v-model="inscricaoLocal"
          :turma-deferida="turmaDeferida"
        />

        <form-subtitle />

        <segunda-secao v-model="inscricaoLocal" />

        <form-subtitle label="Documentos" />

        <setima-secao class="my-4" :inscricao="inscricaoLocal" />

        <form-subtitle label="Endereço" />

        <terceira-secao v-model="inscricaoLocal" />

        <quarta-secao v-model="inscricaoLocal" />

        <form-subtitle label="Unidade de Ensino" />

        <quinta-secao
          v-model="inscricaoLocal"
          :aluno-enturmado="alunoEnturmadoVIN"
          :deferindo-aluno="deferindoAluno"
          :enturmacoes="enturmacoes"
          :loading="loading"
          :transferindo-aluno="transferindoAluno"
          :turma.sync="turma"
          :unidade-ensino.sync="unidadeEnsino"
          :unidades-ensino.sync="unidadesEnsino"
        />

        <form-subtitle label="Observações" />

        <sexta-secao v-model="inscricaoLocal" :loading="loading"></sexta-secao>

        <acoes
          v-model="inscricaoLocal"
          :deferindo-aluno.sync="deferindoAluno"
          :transferindo-aluno.sync="transferindoAluno"
          :enturmacoes="enturmacoes"
          :turma="turma"
          :unidade-ensino="unidadeEnsino"
          :loading="loading"
          @close="$emit('close')"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FormSubtitle from "@/components/FormSubtitle";

import PrimeiraSecao from "./secao-01-protocolo.vue";
import SegundaSecao from "./secao-02-processo.vue";
import TerceiraSecao from "./secao-03-endereco.vue";
import QuartaSecao from "./secao-04-membros-familiares.vue";
import QuintaSecao from "./secao-05-unidade-ensino.vue";
import SextaSecao from "./secao-06-observacao.vue";
import SetimaSecao from "./secao-07-documentos.vue";
import Acoes from "./acoes.vue";

import FamilyMember from "@/models/FamilyMember";
import { isAdmin, isGestor } from "@/plugins/security";
import stringToCpf from "@/utils/stringToCpf";
import { format, parseISO } from "date-fns";

export default {
  name: "dialog-inscricao",

  components: {
    FormSubtitle,
    PrimeiraSecao,
    SegundaSecao,
    TerceiraSecao,
    QuartaSecao,
    QuintaSecao,
    SextaSecao,
    SetimaSecao,
    Acoes,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    unidadesEnsino: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    alunoEnturmadoVIN: false,
    deferindoAluno: false,
    endereco: null,
    enturmacoes: [],
    etapaAtual: null,
    itemEditableState: false,
    loading: false,
    newFamilyMember: new FamilyMember(),
    processoJudicial: false,
    showNewMemberInput: false,
    transferindoAluno: false,
    turma: {},
    turmaDeferida: null,
    turmas: [],
    unidadeEnsino: {},
  }),

  computed: {
    inscricaoLocal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isEditingItem: {
      get() {
        return this.itemEditableState;
      },
      set(newValue) {
        this.itemEditableState = newValue;
      },
    },
  },

  created() {
    this.endereco = this.value.matricula.pessoa.endereco;
    this.processoJudicial = this.value.processo_judicial ? true : false;
  },

  mounted() {
    this.createItemsEditableState();
    this.getEnturmacoes();
    this.getTurmaDeferida();
  },

  methods: {
    isAdmin,
    isGestor,
    format,
    parseISO,
    stringToCpf,

    createItemsEditableState() {
      this.inscricaoLocal.membroFamilia.forEach((item) => {
        this.$set(item, "editing", false);
      });
    },

    getTurmaDeferida() {
      const turmaId = this.inscricaoLocal.turma_deferida;
      if (this.inscricaoLocal.status !== "DEFERIDO" || !turmaId) return;

      this.$erudio
        .get(`turmas/${turmaId}`)
        .then((turma) => {
          this.turmaDeferida = turma;
        })
        .catch((error) => {
          console.error(error);
          this.showMessage("Erro ao carregar a turma de destino", "error");
        });
    },

    getEnturmacoes() {
      this.loading = true;
      this.$erudio
        .get("enturmacoes", {
          params: {
            matricula: this.inscricaoLocal.matricula_id,
            emAndamento: 1,
          },
        })
        .then((enturmacoes) => {
          this.loading = false;
          this.enturmacoes = enturmacoes;

          if (!this.enturmacoes.length) return;

          this.etapaAtual = this.inscricaoLocal.matricula.etapa?.nome || "";

          this.turma = this.enturmacoes.find(
            ({ turma }) => turma.apelido.toUpperCase() === "VIN",
          )?.turma;

          this.alunoEnturmadoVIN = !!this?.turma;
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
          this.showMessage(
            "Não foi possível obter as enturmacões do aluno",
            "error",
          );
        });
    },
  },
};
</script>

<style scoped>
.cvi-dialog-toolbar {
  z-index: 1;
  margin: 0;
  top: 0;
  position: sticky;
  padding: 0;
}
</style>
